import { CheckIcon } from '@tink/core/src/components/atoms/Icons/CheckIcon';
import { ClosedEyecon, OpenEyecon } from '@tink/core/src/components/atoms/Icons/EyeIcon';
import { TextFieldIcon } from './TextField';

export enum PasswordInputIcon {
  CHECK,
  OPEN_EYE,
  CLOSED_EYE,
  NONE,
}

export const getPasswordInputIcon = (
  inputIcon: PasswordInputIcon,
  setInputIcon: (inputIcon: PasswordInputIcon) => void
): TextFieldIcon | undefined => {
  switch (inputIcon) {
    case PasswordInputIcon.CHECK:
      return {
        icon: <CheckIcon color="primary" data-testid="check-icon" />,
      };
    case PasswordInputIcon.OPEN_EYE:
      return {
        onMouseDown: (e) => e.preventDefault(),
        onClick: () => setInputIcon(PasswordInputIcon.CLOSED_EYE),
        icon: <OpenEyecon color="primary" data-testid="eye-icon" />,
      };
    case PasswordInputIcon.CLOSED_EYE:
      return {
        onMouseDown: (e) => e.preventDefault(),
        onClick: () => setInputIcon(PasswordInputIcon.OPEN_EYE),
        icon: <ClosedEyecon color="primary" data-testid="eye-disabled-icon" />,
      };
    default:
      return undefined;
  }
};
